

import store from '@/store'

//全局公共方法 

//跳转客服
export function openKefu() {
	const url = store.state.kefu
	if (url) {
		window.open(url, '_blank')
	}
}

// 获取 URL 参数
export function getQueryParam(key, url) {
	if (!url) {
		url = window.location.href
	}
	key = key.replace(/[[\]]/g, "\\$&")

	const regex = new RegExp("[?&]" + key + "(=([^&#]*)|&|#|$)")
	const results = regex.exec(url)

	if (!results) return null
	if (!results[2]) return ""
	return decodeURIComponent(results[2].replace(/\+/g, " "))
}

// 获取所有参数对象
export function getAllQueryParams(url) {
	if (!url) {
		url = window.location.href
	}
	const params = {}
	const queryString = url.split("?")[1]
	if (!queryString) return params

	queryString.split("&").forEach(param => {
		const [key, value] = param.split("=")
		params[decodeURIComponent(key)] = decodeURIComponent(value || "")
	})
	return params
}